(function ($) {
  Drupal.behaviors.giftGuideCategoryMobile = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      $(document).on('click', '#mobile-categorical-links', function (e) {
        if (this.selectedIndex !== 0) {
          window.location.href = this.value;
        }
      });
    }
  };
})(jQuery);
